// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6 1.69824L10 5.03158V8.99995H14V5.03158L18 1.69824L22 5.03158V22H15.5V18.5C15.5 16.567 13.933 15 12 15C10.067 15 8.5 16.567 8.5 18.5V22H2V5.03158L6 1.69824ZM20 8.99995V5.96833L18 4.30166L16 5.96833V8.99995H20ZM4 8.99995H8V5.96833L6 4.30166L4 5.96833V8.99995Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12 17C11.1716 17 10.5 17.6716 10.5 18.5V22H13.5V18.5C13.5 17.6716 12.8284 17 12 17Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-palace-4-filled')
export default class Palace4FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'palace-4-filled',
    }
  }
}
